module.exports = __webpack_public_path__ + "static/media/carfixio-4.6086b68f.jpg";